import { render, staticRenderFns } from "./cancelacioncuotaenviaje.vue?vue&type=template&id=652cba0e"
import script from "./cancelacioncuotaenviaje.vue?vue&type=script&lang=js"
export * from "./cancelacioncuotaenviaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports